import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, makeStyles, createStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainText: {
      color: theme.palette.dark.main,
      fontSize: "1.6rem",
      width: "280px",
      lineHeight: "2rem",
      fontWeight: "bold",
    },
  })
);

export default function AccountManagementHeader() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Typography className={classes.mainText}>
      {t("account_management")}
    </Typography>
  );
}
